import {registerTileSchema} from '#core/application/schema-registry.js';

import {AbstractVisualFeature} from '../../../visual-feature.js';
import {ClassicCards} from '../classic-cards.js';

import {bannerCardsFactory} from './banner-cards.factory.js';

import BANNER_CARD_DETAILS from './banner-card-details.palette-schema.yaml';
import PALETTE_SCHEMA from './banner-cards.palette-schema.yaml';

registerTileSchema(BANNER_CARD_DETAILS);

class BannerCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'BannerCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return bannerCardsFactory(PALETTE);
    }
}

new BannerCardsFeature(ClassicCards);
